<template>
    <div class="box">
        <transition name="fade" mode="out-in">
            <router-view />
        </transition>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    methods: {
        
    }
}
</script>

<style lang="scss" scoped>
.box {
    width: 100%;
    height: 100%;
    background: #F3F5FA;
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>